import React from 'react'


export const HeroInternas = ({title}) => {
    return (
        <div className="heroInternas">
            <img className="heroInternas--img" src='/images/background/hero-internas.svg' />
            
            <div className="heroInternas--div mb-base">
                <img className="mb-half" src='/images/background/icon-internas.svg' />
                <h1 className="title30">{title}</h1>

            </div>

        </div>
    )
}
